import React from "react";
import { useTranslation } from "react-i18next";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TestimonialItem from "./TestimonialItemBox";
import './testimonialopen.css';

const TestimonialOpen = ({ themeData, testimonials, selectedTheme, theme, handlePrev, handleNext, settings, sliderRef }) => {
  const { t } = useTranslation();

  // This is for several themes which have different type of dynamic background colors(In box styles they are theme9, theme17 and in open style they are theme35, theme51)
  let dynamicMainBgColor = themeData?.dynamicMainBackgroundColor;
  let dynamicBgColor = themeData?.dynamicBackgroundColor;
  let dynamicHeadingColor = themeData?.dynamicTextHeadingColor;
  let dynamicTextDescriptionColor = themeData?.dynamicTextDescriptionColor;
  if (theme === 'temp35' || theme === 'temp51') {
    dynamicMainBgColor = themeData?.dynamicBackgroundColor
    dynamicBgColor = themeData?.dynamicMainBackgroundColor
    dynamicHeadingColor = themeData?.dynamicTextDescriptionColor
    dynamicTextDescriptionColor = themeData?.dynamicTextHeadingColor
  }

  const styles = {
    parentStyle: {
      background: dynamicMainBgColor || "",
      margin: themeData?.margin
    },
    testimonialBoxStyle: {
      backgroundColor: dynamicBgColor || selectedTheme?.bgColor || "",
      padding: '20px',
      marginBottom: '15px',
      boxShadow: selectedTheme?.boxShadow || 'none'
    },
    testimonialOverlayStyle: {
      backgroundColor: themeData?.dynamicCtaColor || selectedTheme?.secBgColor || selectedTheme?.btnColor,
    },
    testimonialHeadingStyle: {
      color: dynamicHeadingColor || selectedTheme?.headingColor || "",
      margin: '0 0 15px 0',
      textAlign: selectedTheme?.headingAlign || "center"
    },
    testimonialNameStyle: {
      color: dynamicTextDescriptionColor ? `${dynamicTextDescriptionColor}90` : selectedTheme?.textColor,
    },
    testimonialDescriptionStyle: {
      color: dynamicTextDescriptionColor ? `${dynamicTextDescriptionColor}90` : selectedTheme?.textColor,
    },
    testimonialContentStyle: {
      fontFamily: selectedTheme?.fontFamily,
    },
    carouselButtonStyle: {
      background: themeData?.dynamicCtaColor || selectedTheme?.btnColor,
      color: themeData?.dynamicCtaTextColor || selectedTheme?.ctaArrow || selectedTheme?.textColor,
    }
  };

  return (
    <article className="testimoniyalbox sec" style={styles.parentStyle}>
      <div className="open-header">
        <h3 className="sectitle" style={styles.testimonialHeadingStyle}>
          {themeData?.headingsObj?.testimonials_Heading || themeData?.testimonialHeading || t("Testimonial")}
        </h3>

        <div className={`${theme}-carousel-btn carousel-open`}>
          <button
            onClick={handlePrev}
            style={styles.carouselButtonStyle}
          >
            <i className="fa fa-angle-left"></i>
          </button>
          <button
            onClick={handleNext}
            style={styles.carouselButtonStyle}
          >
            <i className="fa fa-angle-right"></i>
          </button>
        </div>
      </div>

      <div className="testimonialopen-inner" style={styles.testimonialBoxStyle}>
        <div className="testimonialopen-overlay" style={styles.testimonialOverlayStyle}></div>
        <Slider ref={sliderRef} {...settings}>
          {testimonials.map((val, index) => (
            <TestimonialItem key={index} val={val} styles={styles} />
          ))}
        </Slider>
      </div>
    </article>
  );
};

export default TestimonialOpen;
